import {Box, Button, ButtonGroup, Flex, useToken} from '@chakra-ui/react';
import React from 'react';
import {atom, useRecoilState} from 'recoil';
import {CloseIcon} from '@chakra-ui/icons';
import MenuKit from '../../../components/kits/Menu';
import _ from 'lodash';
import {useSearchParams} from 'react-router-dom';
import Container from "../../../components/Container";

const initialTeamFilterState = {
    city: null,
    team: null,
    iden: null,
};

const teamOrder = atom({
    key: 'Team-nav__order',
    default: initialTeamFilterState,
});

const TeamNav = ({data: TEAM, categoriesData}) => {
    const [filter, setFilter] = useRecoilState(teamOrder);
    const [openFilter, setOpenFilter] = React.useState(false);
    const brand700 = useToken('color', ['brand.700']);
    const [searchParams, setSearchParams] = useSearchParams();
    // const teamsSlug = _.flattenDeep(TEAM.map((item) => item.teams));
    const teamsOffice = TEAM.length ? TEAM?.map((item) => item.office) : null;
    const selectedTeam = searchParams.get('name');
    const teamDropdown = categoriesData?.map((item, index) => {
        return {
            ...item,
            title: item.name,
            value: item.slug,
            onClick: () => {
                setFilter({
                    ...filter,
                    team: index,
                    iden: item.slug,
                });
                setSearchParams({name: item?.slug})
            },
            key: item.slug,
            index,
        }
    })

    React.useLayoutEffect(() => {
        const filteredTeam = teamDropdown?.find((fid) => {
            return fid.slug === selectedTeam;
        });
        if (filteredTeam) {
            setFilter({...filter, team: filteredTeam.index, iden: filteredTeam.key});
        }
    }, [setFilter, selectedTeam]);

    const teamLocationDropdown = _.uniqBy(teamsOffice)
        .reduce((acc, item, key) => {
            acc.push({
                title: item,
                value: item,
                onClick: () =>
                    setFilter({
                        ...filter,
                        city: item,
                    }),
            });
            return acc;
        }, [])
        .filter((fid) => fid.title !== 'None');

    const isAll = Object.values(filter).filter((fid) => fid !== null).length === 0;

    const teamMenu = (
        <MenuKit
            gutter={20}
            buttonProps={{
                children:
                    typeof filter.team === 'number' ? teamDropdown[filter.team].title : 'Team',
                isActive: typeof filter.team === 'number',
            }}
            activeItem={filter.iden}
            options={teamDropdown}
        />
    );

    const locationMenu = (
        <MenuKit
            gutter={20}
            buttonProps={{
                children: filter.city || 'Location',
                isActive: !!filter.city,
            }}
            activeItem={filter.city}
            options={teamLocationDropdown}
        />
    );
    /*

        mobile all filter
        <Button
                                            display={{base: 'felx', md: 'none'}}
                                            onClick={() => {
                                                setOpenFilter(true);
                                                searchParams.delete('name')
                                                setSearchParams(searchParams);
                                                setFilter(initialTeamFilterState);
                                            }}
                                            isActive={isAll}
                                        >
                                            All
                                        </Button>
    */
    return (
        <>
            <Box borderX={'1px'} borderColor={'brandAlpha.200'}>
                <Box position={'relative'}>
                    <Container>
                        <Box pb={'42px'} pt={['42px', 0]} as="section">
                            <Box as="nav">
                                <Flex px={['2.5', '0']} justify="space-between">
                                    <ButtonGroup spacing="1">
                                        <Button
                                            display={{base: 'flex', md: 'flex'}}
                                            onClick={() => {
                                                setFilter(initialTeamFilterState);
                                                searchParams.delete('name')
                                                setSearchParams(searchParams);
                                            }}
                                            isActive={isAll}
                                        >
                                            All
                                        </Button>
                                        
                                        <Box display={{base: 'flex', md: 'flex'}}>{teamMenu}</Box>
                                        <Box display={{base: 'none', md: 'flex'}}>{locationMenu}</Box>
                                        {openFilter && (
                                            <Button
                                                size={'xs'}
                                                variant={'solid'}
                                                bgColor={brand700}
                                                color={'white'}
                                                onClick={() => setOpenFilter(false)}
                                                iconSpacing={0}
                                                borderRadius={'full'}
                                            >
                                                <CloseIcon/>
                                            </Button>
                                        )}
                                    </ButtonGroup>
                                </Flex>
                                {openFilter && (
                                    <Flex px={'2.5'} wrap={'wrap'} gap={'15px'} mt={'15px'}>
                                        <ButtonGroup flexWrap={'wrap'} spacing="3">
                                            {teamMenu}
                                            {locationMenu}
                                        </ButtonGroup>
                                    </Flex>
                                )}
                            </Box>
                        </Box>
                    </Container>
                </Box>
            </Box>
        </>
    );
};

export default TeamNav;
export {teamOrder};
